import React, { useContext } from 'react';
import Button from '@cpg-its/ads.common.button';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmButtonBlock } from '../../models/tcsm-block-models';
import { ButtonWrapper } from '../layout/button-wrapper';
import { handleExternalDestinationClick } from '../../helpers/url-helper';
import { DemographicsContext } from '../../models/demographics-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { AuthenticatedState } from '../../models/authenticated-model';
import { EmploymentState } from '../../../pages/arc/features/employment/employment-model';
import { useBasePath } from '../../hooks/useBasePath';
import { ArcRoutes } from '../../../pages/arc/constants/routes';

interface Props {
    blockData: TcsmButtonBlock,
}

export function TcsmButtonBlockView(props: Props){

    const { blockData } = props;  

    if (!blockData?.linkUrl) return null;

    const history = useHistory();
    const location = useLocation();
    const dispatch = useDispatch();
    const app = useContext(DemographicsContext);
    const authenticatedState = useSelector<TcsmStates, AuthenticatedState>(state => state.authenticatedState);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const employeeSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.PeopleRoot}${ArcRoutes.EmployeeSearch}`);    

    function handleLinkClick(destinationUrl : string){
        handleExternalDestinationClick(destinationUrl, dispatch, history, location, authenticatedState, employmentState, app, employeeSelect);
    }

    return (
        <ButtonWrapper alignment={blockData?.alignment}>
            <Button type='button' buttonStyle='primary' text={blockData?.linkText ? blockData.linkText : blockData.linkUrl } onClick={()=> handleLinkClick(blockData?.linkUrl) } />
        </ButtonWrapper>
    );
}

export default TcsmButtonBlockView;
